export const toSringKVnd = (num) => {
    if (!num) return '0k';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + 'k';
};
